module.exports = "Anthonius\n=========\na son of two\nbrother to five\nhusband to one\nfather to one\n\na PHP Developer\n\nSkills\n------\nSymfony Zend Angular React Laravel\nbehat phpunit phpspec\n\nTools\n-----\ngit grunt/gulp docker vagrant\n\n\nContact\n-------\n* me at itstoni dot com\n\n\nAvailability\n------------\nI am right now still working on a few projects.\nPlease contact me and I will let you know\nif I can do some work for you.\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./work.txt
// module id = 89
// module chunks = 0 1